import { Box, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import type { OrganizationEntry } from '@/api/user/types';
import { setOrganizationId } from '@/context/authClient';
import { useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/api/core/queryKeys';

interface SelectOrganizationProps {
  organizations: OrganizationEntry[];
}

function SelectOrganization({ organizations }: SelectOrganizationProps) {
  const { t } = useTranslation('common');
  const queryClient = useQueryClient();

  const handleSelect = (orgId: string) => {
    setOrganizationId(orgId);
    queryClient.invalidateQueries({ queryKey: queryKeys.user });
  };

  return (
    <Flex minH="100vh" align="center" justify="center" bg="gray.50" px={4}>
      <Box bg="white" p={8} rounded="lg" shadow="md" w="full" maxW="400px">
        <Flex direction="column" align="center" mb={6}>
          <img src="/sindi-black.svg" alt="Sindi" style={{ height: '40px' }} />
        </Flex>

        <Text fontSize="sm" fontWeight="medium" mb={3}>
          {t('selectOrganization')}
        </Text>

        <Flex direction="column" gap={2}>
          {organizations.map((org) => (
            <Box
              key={org.id}
              as="button"
              w="full"
              p={3}
              borderRadius="md"
              border="1px solid"
              borderColor="gray.200"
              textAlign="left"
              cursor="pointer"
              _hover={{ borderColor: 'gray.400', bg: 'gray.50' }}
              onClick={() => handleSelect(org.id)}
            >
              <Text fontSize="sm" fontWeight="medium">
                {org.name}
              </Text>
            </Box>
          ))}
        </Flex>
      </Box>
    </Flex>
  );
}

export default SelectOrganization;
